import React from "react";
import bg1 from "../assets/bg2.png";
import bg2 from "../assets/bg1.png";
import loan4 from "../assets/loan4.png";
import loan2 from "../assets/loan5.png";
import loan3 from "../assets/loan3.png";
import loan5 from "../assets/loan2.png";
import loan1 from "../assets/loan1.png";

export default function GoldLoanPage() {
  const testimonials = [
    {
      name: "Rahul Singh",
      city: "Delhi",
      text: "The loan process was very smooth and quick. I didn’t expect approval to be this fast. Really happy with the service!",
    },
    {
      name: "Anjali Mehta",
      city: "Mumbai",
      text: "Very professional and transparent. The staff helped me understand every step clearly!",
    },
    {
      name: "Ramesh Kumar",
      city: "Bangalore",
      text: "I’ve taken loans before, but none were as easy and fast as this. Great experience!",
    },
    {
      name: "Neha Sharma",
      city: "Pune",
      text: "Loved the quick processing! The team was supportive throughout the journey.",
    },
    {
      name: "Amit Verma",
      city: "Chennai",
      text: "A smooth experience from start to finish. Highly recommend to anyone in need of a loan.",
    },
    {
      name: "Suresh Patel",
      city: "Ahmedabad",
      text: "Quick, reliable, and easy to communicate. Thank you for the great service!",
    },
  ];

  const chunkSize = 3;
  const slides = [];
  for (let i = 0; i < testimonials.length; i += chunkSize) {
    slides.push(testimonials.slice(i, i + chunkSize));
  }

  return (
    <>
      <div
        style={{
          backgroundImage: `url(${bg1})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          minHeight: "100vh",
          padding: "4rem 0",
          position: "relative",
          zIndex: 1,
        }}
      >
        <div className="text-center mb-5 mt-4">
          <div className="d-flex justify-content-center align-items-center mb-3 flex-wrap">
            <img src={loan4} alt="loan1" style={{ width: "100px" }} />
            <h4
              style={{
                fontWeight: "600",
                color: "#2d2d2d",
                margin: "0 1rem",
                textAlign: "center",
              }}
            >
              Trusted by People Like You, for Loans That Truly Care
            </h4>
            <img src={loan2} alt="loan2" style={{ width: "100px" }} />
          </div>
        </div>

        <div className="row d-flex justify-content-center mt-5">
          <div className="col-10">
            <div
              id="testimonialCarousel"
              className="carousel slide"
              data-bs-ride="carousel"
              data-bs-interval="4000"
            >
              <div
                className="carousel-indicators"
                style={{
                  position: "absolute",
                  bottom: "-40px",
                }}
              >
                {slides.map((_, index) => (
                  <button
                    key={index}
                    type="button"
                    data-bs-target="#testimonialCarousel"
                    data-bs-slide-to={index}
                    className={index === 0 ? "active" : ""}
                    aria-current={index === 0 ? "true" : undefined}
                    aria-label={`Slide ${index + 1}`}
                    style={{
                      backgroundColor: "#000",
                      width: "10px",
                      height: "10px",
                      borderRadius: "50%",
                    }}
                  ></button>
                ))}
              </div>

              <div className="carousel-inner">
                {slides.map((group, index) => (
                  <div
                    key={index}
                    className={`carousel-item ${index === 0 ? "active" : ""}`}
                  >
                    <div className="container">
                      <div className="row justify-content-center">
                        {group.map((t, i) => (
                          <div key={i} className="col-md-4 mb-4">
                            <div
                              className="card shadow-sm"
                              style={{
                                borderRadius: "10px",
                                padding: "18px",
                                height: "100%",
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "space-between",
                              }}
                            >
                              <div>
                                <div
                                  style={{
                                    color: "#f6b100",
                                    marginBottom: "8px",
                                  }}
                                >
                                  {"★★★★★"}
                                </div>
                                <p style={{ fontSize: "14px", color: "#444" }}>
                                  {t.text}
                                </p>
                              </div>

                              <div className="d-flex align-items-center mt-3">
                                <div
                                  style={{
                                    width: "35px",
                                    height: "35px",
                                    borderRadius: "50%",
                                    border: "2px solid #ddd",
                                    marginRight: "8px",
                                  }}
                                ></div>
                                <div>
                                  <strong style={{ fontSize: "13px" }}>
                                    {t.name}
                                  </strong>
                                  <p
                                    style={{
                                      fontSize: "12px",
                                      color: "#666",
                                      margin: 0,
                                    }}
                                  >
                                    {t.city}
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        style={{
          backgroundImage: `url(${bg2})`,
          backgroundSize: "cover",
          backgroundPosition: "top center",
          backgroundRepeat: "no-repeat",
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: "2rem",
          position: "relative",
          marginTop: "-130px",
          zIndex: 2,
        }}
      >
        <div
          className="container "
          style={{ paddingRight: "6rem", paddingLeft: "6rem" }}
        >
          <div className="row align-items-center justify-content-center text-center text-md-start">
            <div className="col-md-6 mb-4 mb-md-0" style={{ zIndex: 3 }}>
              <h3
                style={{ fontWeight: 600, marginBottom: "3rem", color: "#fff" }}
              >
                To know more Enquire Now
                <br /> or Visit your nearest Shubh Paisa Branch
              </h3>

              <h5
                style={{ fontWeight: 500, marginBottom: "2rem", color: "#fff" }}
              >
                Gold Loan Disbursement Options
              </h5>
              <div className="row mt-5">
                <div className="col-4">
                  <img src={loan3} alt="loan1" style={{ width: "100px" }} />
                  <p
                    className="mt-3"
                    style={{ color: "#fff", fontSize: ".9rem" }}
                  >
                    Instant Cash
                  </p>
                </div>
                <div className="col">
                  <img src={loan5} alt="loan2" style={{ width: "100px" }} />
                  <p
                    className="mt-3"
                    style={{ color: "#fff", fontSize: ".9rem" }}
                  >
                    Direct Online Credit
                  </p>
                </div>
              </div>
            </div>

            <div
              className="col-md-6 position-relative text-center"
              style={{
                minHeight: "520px",
                overflow: "visible",
              }}
            >
              <img
                src={loan1}
                alt="Gold Loan Repayment Options"
                className="img-fluid"
                style={{
                  position: "absolute",
                  bottom: "-90px",
                  right: "0",
                  width: "35vw",
                  maxWidth: "100%",
                  height: "auto",
                  borderRadius: "20px",
                  zIndex: 2,
                  boxShadow: "0 8px 30px rgba(0,0,0,0.2)",
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
